import {useCallback, useContext, useEffect, useState} from 'react';
import {UploadButton} from '~/CreateFabricGreetingCard/components/UploadButton/UploadButton';
import {DeleteButton} from '~/CreateFabricGreetingCard/routes/CardCreateDesign/components/DeleteButton';
import {DoneButton} from '~/CreateFabricGreetingCard/routes/CardCreateDesign/components/DoneButton';
import {ImageSize} from '~/CreateFabricGreetingCard/routes/CardCreateDesign/components/ImageSize';
import {ResetImageXY} from '~/CreateFabricGreetingCard/routes/CardCreateDesign/components/ResetImageXY';
import {UyoImageRotate} from '~/CreateFabricGreetingCard/routes/CardCreateDesign/components/UyoImageRotate';
import {Header} from '~/common/fabric/Card/components/Header/Header';
import {FabricContext} from '~/common/fabric/context/FabricContext';

import './UyoControl.sass';

export const UyoControl = ({editorDisabled = false, eventId}) => {
  const {canvas, activeObjects} = useContext(FabricContext);
  const [id, setId] = useState(null);
  const [uyoImage, setUyoImage] = useState(null);
  const [active, setActive] = useState(false);

  useEffect(() => {
    if (activeObjects?.[0]?.type === 'uYOImage') {
      setActive(true);
      const [activeImage] = activeObjects;
      setUyoImage(activeImage);
      setId(activeObjects[0].id);
    } else {
      setActive(false);
    }
  }, [activeObjects]);

  const imageUploadedCallback = useCallback(
    (uploadedUyo) => {
      canvas.setActiveObject(uploadedUyo).renderAll();
    },
    [canvas]
  );

  if (!active) {
    return null;
  }

  return (
    <div className="card_editor">
      <div className="edit_box image-editor">
        <Header
          title="Photo Editor"
          extra={
            <ResetImageXY
              disabled={editorDisabled}
              label="Reset position"
              dataQaId="step1-imagexy-reset"
              uyoImage={uyoImage}
            />
          }
        />
        <div className="uyo-control__edit-actions">
          <ImageSize id={id} />
          <UyoImageRotate btnText="Rotate" disabled={editorDisabled} />
        </div>
        <div className="uyo-control__remove-actions">
          <UploadButton
            btnText="Upload New"
            eventId={eventId}
            id={id}
            index={id}
            callback={imageUploadedCallback}
            isInPhotoEditor
          />
          <DeleteButton btnText="Remove Current" disabled={editorDisabled} />
        </div>
        <DoneButton handleDoneClick={() => setActive(false)} />
      </div>
    </div>
  );
};
